import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { SectionHeading } from "../SectionHeading";
import { Reveal } from "../Reveal";
import { Icon } from "../Icon";
import { SERVICES } from "../../data/content";
import { useLang } from "../../i18n/LanguageContext";

const Card = ({ item, index }) => {
  const { t } = useLang();
  return (
    <Reveal delay={(index % 4) * 0.08} className="h-full">
      <Link
        to={`/services/${item.slug}`}
        data-testid={`service-card-${item.slug}`}
        className="group relative flex h-full flex-col overflow-hidden rounded-2xl border border-white/[0.07] bg-[#0A0E17] p-8 transition-colors duration-500 hover:border-[#3B82F6]/40"
      >
        <div className="flex h-11 w-11 items-center justify-center rounded-xl border border-white/10 bg-white/[0.03] text-[#60A5FA] transition-all duration-500 group-hover:border-[#3B82F6]/50 group-hover:text-white group-hover:shadow-[0_0_24px_rgba(59,130,246,0.35)]">
          <Icon name={item.icon} className="h-5 w-5" />
        </div>
        <h3 className="mt-6 text-xl font-medium tracking-tight text-white">{t(item.name)}</h3>
        <p className="mt-3 text-sm leading-relaxed text-white/55">{t(item.desc)}</p>
        <ul className="mt-6 space-y-2">
          {item.examples.slice(0, 4).map((ex, i) => (
            <li key={i} className="text-sm text-white/40">
              {t(ex)}
            </li>
          ))}
        </ul>
        <span className="mt-auto pt-6 inline-flex items-center gap-1.5 text-sm text-[#93c5fd] group-hover:text-white transition-colors">
          {t(item.cta)}
          <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
        </span>
      </Link>
    </Reveal>
  );
};

export const ServiceCards = () => {
  const { t } = useLang();
  return (
    <section id="services" data-testid="service-cards-section" className="relative py-24 md:py-32 border-t border-white/5">
      <div className="mx-auto max-w-7xl px-6 md:px-12">
        <SectionHeading overline={t(SERVICES.overline)} title={t(SERVICES.title)} />
        <div className="mt-16 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {SERVICES.items.map((item, i) => (
            <Card key={item.slug} item={item} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
};
